module.exports = __webpack_public_path__ + "img/aeroland-sass-image-04.db819bd4.jpg";